import React from 'react';

export default React.createContext({
    selectedColumn: null,
    setSelectedColumn: null,
});
